module.exports = __webpack_public_path__ + "static/media/opps_img_human.da787b41.svg";